module.exports = __webpack_public_path__ + "static/media/birdsfx.ba87afe9.wav";